module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/T1x4zL/images/cover.jpg?1690496876516",
      "alt": "This image is the cover for the book Dictionary of Foreign Words and Phrases"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dictionary of Foreign Words and Phrases\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A fascinating A-to-Z reference to foreign words and phrases that have become part of contemporary English usage.")])]), _c('p', [_vm._v(" The English language has been greatly enriched by a vast array of words and phrases imported from other tongues, such as "), _c('i', [_vm._v("comrade")]), _vm._v(", "), _c('i', [_vm._v("chateau")]), _vm._v(", "), _c('i', [_vm._v("wunderkind")]), _vm._v(", and "), _c('i', [_vm._v("vox populi")]), _vm._v(". For the average English speaker, many are bound to be familiar. Some may even appear to be standard English, while others may seem, well,"), _c('i'), _vm._v("foreign. "), _c('i', [_vm._v("A Dictionary of Foreign Words and Phrases")]), _vm._v(" presents a comprehensive list of such terms, with entries that reveal their meanings and etymologies. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      A J Bliss\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Philosophical Library/Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0